import React from 'react';
import MinusIcon from '../../../../../assets/minus-icon.svg';
import PlusIcon from '../../../../../assets/plus-icon.svg';
import { FMButton } from '@own/fds-react';
export const ViewMoreTopics = ({
    isOpen,
    showMoreText,
    onClick,
}: {
    isOpen: boolean;
    showMoreText?: string;
    onClick?: () => void;
}) => {
    const handleOnClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <FMButton
            type={'tertiary'}
            aria-label={showMoreText ? showMoreText : 'show more'}
            label={
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    {showMoreText}
                    <div className="plus-minus-icon-container">
                        {isOpen ? (
                            <img src={MinusIcon} className="open" alt="" />
                        ) : (
                            <img
                                src={PlusIcon}
                                className="close"
                                alt=""
                                style={{ color: 'red' }}
                            />
                        )}
                    </div>
                </div>
            }
            onClick={handleOnClick}
        ></FMButton>
    );
};
